import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const sharedClasses = `inline-block text-center bg-terracotta text-white rounded-full px-8 py-4 font-semibold text-lg md:text-xl shadow-lg hover:bg-terracotta-hover hover:shadow-xl transition-colors duration-300 ${className}`;
  const handleClick = () => {
    if (href) {
      trackAddToCart();
    }
    onClick?.();
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} onClick={handleClick} className={sharedClasses} data-id="element-258">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={sharedClasses} data-id="element-259">
      {children}
    </motion.button>;
}